import { Theme } from '@mui/material';

// Fixed heights
export const MOBILE_HEADER_HEIGHT = '88px';
export const MOBILE_HEADER_HEIGHT_NUMBER = 88;

// Home content start when the company-switcher line is shown. Home is the only
// header with a logo, which pushes the switcher line just below the fixed 88px
// header; starting content here keeps the line clear of the (higher-z) content
// layer so it stays tappable. Tuned to Home's logo+welcome height — revisit if
// that header's layout changes. (Avoids a z-index bump, which would bleed the
// header over detail overlays.)
export const MOBILE_HOME_SWITCHER_CONTENT_TOP = '98px';

// SEE-1715: height of the device status bar the page draws under, set on <html>
// by the mobile shell. 0 in browsers and in shells that predate it.
export const NATIVE_SAFE_TOP = 'var(--native-safe-top, 0px)';

export const MOBILE_NAV_HEIGHT = '89px';
export const MOBILE_NAV_HEIGHT_NUMBER = 89;

// Card dimensions and styling
export const CARD_DIMENSIONS = {
  maxWidth: 360,
  aspectRatio: 1.6,
  viewportWidth: '85vw',
  borderRadius: '12px',
} as const;

// Background sizes in vh units
export const BACKGROUND_SIZES = {
  SHOW_HEADER: MOBILE_HEADER_HEIGHT,
  FULL: '100vh',
  LARGE: '70vh',
  HALF: '50vh',
  MEDIUM: '40vh',
  DEFAULT: '30vh',
  MINIMAL: '20vh',
  TITLE: '10vh',
  NONE: '0',
} as const;

export const BACKGROUND_SIZES_v2 = {
  SHOW_HEADER: MOBILE_HEADER_HEIGHT,
};

export const getDimensions = (theme: Theme) => ({
  logoBackground: { width: 420, height: 420 }, // Keep custom for background logo
  progressBarHeight: theme.spacing(0.75), // 6px
  chipHeight: theme.spacing(3), // 24px
  chipMinWidth: theme.spacing(4), // 32px
  cardBorderRadius: theme.spacing(0.5), // 4px (theme spacing 4 = 32px, so 0.5 = 4px)
  searchBorderRadius: theme.spacing(1.5), // 12px
  progressBorderRadius: theme.spacing(1.5), // 12px
});

// Z-index layers

export const Z_LAYERS = {
  BACKGROUND: 0,
  WHITE_BACKGROUND: 1,
  CONTENT: 2,
  HEADER: 3,
  NAV: 1000,
  MOBILE_BOTTOM_SHEET_BACKDROP: 1400,
  MOBILE_BOTTOM_SHEET: 1401,
  MOBILE_LOADING_OVERLAY: 9999,
} as const;

// Padding and spacing
// Navigation
export const NAV_ROUTES = {
  home: '/mobile-demo',
  transactions: '/transactions',
  reimbursements: '/reimbursements',
  menu: '/settings',
} as const;

export const NAV_SPACING = {
  small: { xs: 0.5, sm: 1, md: 1.25 },
  medium: { xs: 1, sm: 1.5, md: 2 },
  large: { xs: 2, sm: 3, md: 4 },
  navigation: { xs: 6, sm: 20, md: 24 },
} as const;

export const NAV_ICON_SIZE = '48px';

// Mobile spacing
export const MOBILE_SPACING = {
  // Header padding
  HEADER_TOP: '16px',
  HEADER_HORIZONTAL: '16px',
  HEADER_BOTTOM: '16px',

  // Navigation padding
  NAV_PADDING: 2,

  // Safe area handling
  SAFE_AREA_TOP: 'env(safe-area-inset-top, 0px)',
  SAFE_AREA_BOTTOM: 'env(safe-area-inset-bottom, 0px)',
} as const;

export const SPACING = {
  small: { xs: 0.5, sm: 1, md: 1.25 }, // Small gaps
  medium: { xs: 1, sm: 1.5, md: 2 }, // Medium gaps
  large: { xs: 2, sm: 3, md: 4 }, // Large gaps
  navigation: { xs: 6, sm: 8, md: 10 }, // Navigation gaps
} as const;

// Standard MUI responsive icon sizes (viewport width units)
export const ICON_SIZES = {
  small: { xs: '3.2vw', sm: '4vw', md: '4.8vw' }, // Small icons (header logo)
  medium: { xs: '4.4vw', sm: '5.5vw', md: '6.6vw' }, // Medium icons (notifications, search)
  large: { xs: '5.2vw', sm: '6.5vw', md: '7.8vw' }, // Large icons (card elements)
} as const;
